var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepartmentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5Z",
    fill: "#FCFFE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5Z",
    stroke: "#3F6600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.823 15.1063C23.3748 15.1063 23.6052 14.3973 23.157 14.0705L16.3373 9.10982C16.2399 9.03847 16.1223 9 16.0016 9C15.8809 9 15.7633 9.03847 15.6659 9.10982L8.84624 14.0705C8.39803 14.3955 8.62838 15.1063 9.18196 15.1063H10.2873V21.7848H9.0016C8.92303 21.7848 8.85874 21.8491 8.85874 21.9277V22.8563C8.85874 22.9348 8.92303 22.9991 9.0016 22.9991H23.0016C23.0802 22.9991 23.1445 22.9348 23.1445 22.8563V21.9277C23.1445 21.8491 23.0802 21.7848 23.0016 21.7848H21.7159V15.1063H22.823ZM16.0016 10.3687L20.8427 13.8902H11.1605L16.0016 10.3687ZM11.573 15.1063H13.6623V21.7848H11.573V15.1063ZM14.948 15.1063H17.0373V21.7848H14.948V15.1063ZM20.4302 21.7848H18.323V15.1063H20.4302V21.7848Z",
    fill: "#3F6600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentIcon);
export default __webpack_public_path__ + "static/media/departmentIcon.21d25e077ad485c3ca68f8783128ddd2.svg";
export { ForwardRef as ReactComponent };